// extracted by mini-css-extract-plugin
export var header = "_fy-0";